import apiWithRefreshToken from './apiWithRefreshToken';

const updateLoyaltyTierPopup = async () => {
  try {
    const response = await apiWithRefreshToken.get(
      '/myaccount/api/loyalty-tier/update-tier-popup',
      {
        baseURL: process.env.NEXT_PUBLIC_URL,
      }
    );
    return response?.data;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export default { updateLoyaltyTierPopup };
